import { TextBadgeColor } from "@bps/fluent-ui";
import {
  BillingStatuses,
  ItemType,
  PaymentStatuses
} from "@libs/gateways/billing/BillingGateway.dtos.ts";

export const paymentStatusColours: Record<PaymentStatuses, TextBadgeColor> = {
  [PaymentStatuses.paid]: TextBadgeColor.green,
  [PaymentStatuses.unpaid]: TextBadgeColor.red,
  [PaymentStatuses.part]: TextBadgeColor.red,
  [PaymentStatuses.overpaid]: TextBadgeColor.grey,
  [PaymentStatuses.cancelled]: TextBadgeColor.grey
};

export const billingStatusColours: Record<BillingStatuses, TextBadgeColor> = {
  [BillingStatuses.cancelled]: TextBadgeColor.lightGrey,
  [BillingStatuses.adjusted]: TextBadgeColor.yellow,
  [BillingStatuses.current]: TextBadgeColor.grey
};

export const itemTypeColours: Record<ItemType, TextBadgeColor> = {
  [ItemType.WriteOff]: TextBadgeColor.lightGrey,
  [ItemType.CreditNote]: TextBadgeColor.blue,
  [ItemType.Payment]: TextBadgeColor.green,
  [ItemType.Refund]: TextBadgeColor.lightGrey,
  [ItemType.Allocation]: TextBadgeColor.green
} as Record<ItemType, TextBadgeColor>;
